2<template>
  <div v-if="!userIsBook">
    <user-benefits-table
      :userId="userId"
      @showConfirmDeactivationModal="showConfirmDeactivationModal"
      @showRequestSalaryModal="showRequestSalaryModal"
      :columns="columns"
    ></user-benefits-table>
    <user-request-gross-salary-modal
      :open.sync="showRequestGrossSalaryModalFlag"
      :featureData="featureData"
      v-if="showRequestGrossSalaryModalFlag"
    ></user-request-gross-salary-modal>

    <confirm-modal
      v-if="showConfirmDeactivationModalFlag"
      :open.sync="showConfirmDeactivationModalFlag"
      :title="'benefits_confirm_ret_flex_deactivation_with_accumulative_benefits'"
      :dismissText="'ACTION_CANCEL'"
      :acceptText="'benefits_confirm_acumulation_removal_action_confirm'"
      :message="''"
      ignoreDefaultMessage
      @accept="confirmSetFeature"
    >
      <template v-slot:additional>

        <p class="Fuell-Text text-center">
          <i18n path="benefits_confirm_acumulation_removal_warning">
            <template v-slot:balance>
              <span class="text-primary">
                {{userConfirmationModalBalance}} €
              </span>
            </template>
            <template v-slot:activityGroup>
              <span class="text-primary">
                {{$t(userRetFlexActivityGroup)}}
              </span>
            </template>

          </i18n>
        </p>
      </template>

    </confirm-modal>

  </div>
</template>

<script>
import UserBenefitsTable from '@/modules/benefits/_components/users/UsersBenefitsTable'
import _benefitsSharedMethods from '@/modules/benefits/_mixins/_benefitsSharedMethods'
import _userBenefitsIndexHandler from '@/modules/benefits/_mixins/_userBenefitsIndexHandler'
const UserRequestGrossSalaryModal = () => import('@/modules/benefits/_components/users/UserRequestGrossSalaryModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'UserBenefitsIndex',
  components: { UserBenefitsTable, ConfirmModal, UserRequestGrossSalaryModal },
  mixins: [_benefitsSharedMethods, _userBenefitsIndexHandler],
  computed: {
    userId () {
      return Number.parseInt(this.$route.params.id)
    },
    user () {
      return this.$store.getters['UsersStore/users'].find(el => el.id === this.userId) || false
    },
    userIsBook () {
      return this.userRole.some(el => this.$store.getters['UsersStore/accountingRoles'].includes(el))
    },
    userRole () {
      return this.user && this.user.roles.length > 0 ? this.user.roles : []
    },
    columns () {
      return this.$store.getters['BenefitsStore/userRetflexColumns'].filter(el => {
        if (this.isImpersonating) {
          return el
        } else {
          return !el.superAdminOnly
        }
      }).map(el => {
        if (el.key.includes('current') && !el.key.includes('insurance') && !el.key.includes('education') && !el.key.includes('nursery')) {
          return {
            key: el.key,
            name: this.generateColumnLabel(el.key),
            visible: el.visible,
            modifiable: el.modifiable,
            template: el.template
          }
        } else {
          return el
        }
      })
    }

  },
  data () {
    return {
      showRequestGrossSalaryModalFlag: false,
      showConfirmDeactivationModalFlag: false,
      featureData: {},
      userConfirmationModalBalance: '',
      userRetFlexActivityGroup: ''

    }
  },
  methods: {
    showConfirmDeactivationModal (event) {
      this.featureData = event
      let user = this.$store.getters['UsersStore/users'].find(el => el.id === event.id)
      if (user) {
        let budgetToCheck = user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === event.activityGroup)
        this.userConfirmationModalBalance = budgetToCheck.assigned
        this.userRetFlexActivityGroup = this.$t(`activity_group__${event.activityGroup}`)
      }
      this.showConfirmDeactivationModalFlag = true
    },
    showRequestSalaryModal (event) {
      this.featureData = event
      this.showRequestGrossSalaryModalFlag = true
    },

    confirmSetFeature () {
      const { id, feature } = this.featureData
      this.setUserFeature(id, feature)
    }

  }

}
</script>

<style>
</style>
